import { render, staticRenderFns } from "./transactions.vue?vue&type=template&id=25820b3e&scoped=true&"
import script from "./transactions.vue?vue&type=script&lang=js&"
export * from "./transactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25820b3e",
  null
  
)

export default component.exports